import {Scenario, StaticMethods, Label} from './GeneralModels';
import {HealthScenarios} from './SamanHealthFamilyModels';
import {AppSettingsService} from '../services/app-settings.service';

export class MobileInsurance {
  icon: string;

  constructor(public requestID: number, public companyName: string, private deviceType: string, public deviceModel: string) {
    this.icon = MobileStaticMethods.getIcon(deviceType);
  }

  getRequestID() {
    return this.requestID;
  }

  getCompanyName() {
    return this.companyName;
  }
}

export class MobileInsuranceDetails {
  private requestID: number;
  private devicePrice: number;
  private deviceType: string;
  private deviceBrand: string;
  private deviceModel: string;
  private franchise: string;
  private companyName: string;
  private offer: boolean;
  private formsSubmission: boolean;
  private deviceBoxPicture: boolean;
  private deviceBackPicture: boolean;
  private deviceFrontPicture: boolean;
  private personalInfo: boolean;
  private deviceInfo: boolean;
  private paid: boolean;
  private insuranceReleased: boolean;
  private viewArray: any;
  private currentStep: string;
  private requestToken: string;

  constructor(request, scenario) {
    this.requestID = request.requestID;
    this.devicePrice = request.devicePrice;
    this.deviceType = request.deviceType;
    this.deviceBrand = request.deviceBrand;
    this.deviceModel = request.deviceModel;
    this.franchise = request.franchise;
    this.companyName = request.companyName;
    this.offer = request.offer;
    this.deviceBoxPicture = request.deviceBoxPicture;
    this.deviceBackPicture = request.deviceBackPicture;
    this.deviceFrontPicture = request.deviceFrontPicture;
    this.formsSubmission = request.formsSubmission;
    this.paid = request.paid;
    this.insuranceReleased = request.insuranceReleased;
    this.requestToken = request.requestToken;
    this.currentStep = StaticMethods.setStep(scenario, this.checkStepStatus, this);
    this.setViewArray();
  }

  setViewArray() {
    this.viewArray = {
      deviceModel: this.deviceModel,
      deviceBrand: this.deviceBrand,
      deviceType: this.deviceType,
      devicePrice: this.devicePrice,
      companyName: this.companyName,
      franchise: this.franchise,
      DeviceBackPicture: this.deviceBackPicture ? 'true_FILE_STATUS' : 'false_FILE_STATUS',
      DeviceBoxPicture: this.deviceBoxPicture ? 'true_FILE_STATUS' : 'false_FILE_STATUS',
      DeviceFrontPicture: this.deviceFrontPicture ? 'true_FILE_STATUS' : 'false_FILE_STATUS',
      deviceInfo: this.formsSubmission ? 'true_SUBMISSION_STATUS' : 'false_SUBMISSION_STATUS',
      paid_label: this.paid ? 'true_payment' : 'false_payment'
    };
    if (this.requestToken) {
      this.viewArray.requestToken = this.requestToken;
    }
    this.viewArray.status = this.currentStep;
  }

  getRequestID() {
    return this.requestID;
  }

  getDevicePrice() {
    return this.requestID;
  }

  getType() {
    return this.deviceType;
  }

  getBrand() {
    return this.deviceBrand;
  }

  getModel() {
    return this.deviceModel;
  }

  getFranchise() {
    return this.franchise;
  }

  getCompanyName() {
    return this.companyName;
  }

  getOffer() {
    return this.offer;
  }

  getBoxPicture() {
    return this.deviceBoxPicture;
  }

  getBackPicture() {
    return this.deviceBackPicture;
  }

  getFrontPicture() {
    return this.deviceFrontPicture;
  }

  getPersonalInfo() {
    return this.personalInfo;
  }

  getDeviceInfo() {
    return this.deviceInfo;
  }

  isPaid() {
    return this.paid;
  }

  getViewArray() {
    return this.viewArray;
  }

  getStep() {
    return this.currentStep;
  }

  private checkStepStatus = (step: string, object: MobileInsuranceDetails): boolean => {
    switch (step) {
      case MobileScenarios.fileUploaded:
        return object.deviceFrontPicture &&
          object.deviceBackPicture &&
          object.deviceBoxPicture;
      case MobileScenarios.paid:
        return object.paid;
      case MobileScenarios.formSubmitted:
        return object.formsSubmission;
      case MobileScenarios.waitingForRelease:
        return object.insuranceReleased;
      case MobileScenarios.insuranceReleased:
        return !object.insuranceReleased;
    }
  }

  getFileType(translationsService: AppSettingsService): Label {
    return !this.deviceFrontPicture ? new Label(MobileScenarios.frontPicture,
      translationsService.translateEnglish(MobileScenarios.frontPicture))
      // tslint:disable-next-line:max-line-length
      : !this.deviceBackPicture ? new Label(MobileScenarios.backPicture,
        translationsService.translateEnglish(MobileScenarios.backPicture))
        // tslint:disable-next-line:max-line-length
        : !this.deviceBoxPicture ? new Label(MobileScenarios.boxPicture,
          translationsService.translateEnglish(MobileScenarios.boxPicture)) : null;
  }
}

export class MobileStaticMethods {
  static getIcon(deviceType) {
    switch (deviceType) {
  case 'laptop':
    return 'ico-smartphone-outline';
  case 'tablet':
    return 'ico-smartphone-outline';
  default:
    return 'ico-smartphone-outline';
  }}
}

export class MobileScenarios {
  static readonly fileUploaded = 'fileUploaded';
  static readonly frontPicture = 'DeviceFrontPicture';
  static readonly backPicture = 'DeviceBackPicture';
  static readonly boxPicture = 'DeviceBoxPicture';
  static readonly formSubmitted = 'formSubmitted';
  static readonly paid = 'paid';
  static readonly waitingForRelease = 'waitingForRelease';
  static readonly insuranceReleased = 'insuranceReleased';
  static generalScenario = new Scenario([
    MobileScenarios.fileUploaded,
    MobileScenarios.formSubmitted,
    MobileScenarios.paid,
    MobileScenarios.waitingForRelease,
    MobileScenarios.insuranceReleased,
  ]);

  static B2BScenario = new Scenario([
    MobileScenarios.fileUploaded,
    MobileScenarios.formSubmitted,
    MobileScenarios.paid,
    MobileScenarios.waitingForRelease,
    MobileScenarios.insuranceReleased,
  ]);

  constructor() {
  }
}
